export default __webpack_public_path__ + "static/Mallorie-Regular-02936930bf358ecfcc9fcff9fc53ddf6.woff2";